import React from 'react';

import { useScrollToTarget } from '@/core/features/link/use-scroll-to-target';

export default function ScrollToComponentLink({
    children,
    className,
    componentIri,
    onClick,
    qaId,
    style,
}: React.PropsWithChildren<{
    className?: string;
    componentIri: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    qaId?: string;
    style?: React.CSSProperties;
}>) {
    const { scrollTo } = useScrollToTarget(componentIri);
    const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);
        scrollTo();
    };

    return (
        <button
            className={`pointer ${className ?? ''}`}
            data-qa-id={qaId}
            onClick={handleOnClick}
            style={style}
        >
            {children}
        </button>
    );
}
